import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../services/language/language.service';
import {
  DEFAULT_LANGUAGES,
  IMessageText,
  INormalText,
  ITextLanguageValue,
  LanguagePrefix,
} from '@web/dtos';

@Pipe({
  name: 'language',
  standalone: true,
  pure: false,
})
@Injectable({
  providedIn: 'root',
})
export class LanguagePipe implements PipeTransform {
  private readonly languageService: LanguageService = inject(LanguageService);

  transform(
    texts: INormalText | IMessageText | INormalText[] | IMessageText[]
  ): string {
    const standardPrefix: LanguagePrefix = DEFAULT_LANGUAGES[0].prefix;
    if (Array.isArray(texts)) {
      return (
        texts?.[0]?.text.values.filter(
          (value: ITextLanguageValue) =>
            value.languagePrefix ===
            this.languageService.activeLanguage().prefix
        )[0]?.value ??
        texts?.[0]?.text.values.filter(
          (value: ITextLanguageValue) => value.languagePrefix === standardPrefix
        )[0]?.value ??
        ''
      );
    } else {
      return (
        texts?.text.values.filter(
          (value: ITextLanguageValue) =>
            value.languagePrefix ===
            this.languageService.activeLanguage().prefix
        )[0]?.value ??
        texts?.text.values.filter(
          (value: ITextLanguageValue) => value.languagePrefix === standardPrefix
        )[0]?.value ??
        ''
      );
    }
  }
}
